<div class="snapshot-modal-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">Snapshots ({{ filteredSnapshots().length }})</h2>

    <div class="header-actions">
      <button
        mat-icon-button
        class="search-toggle-button"
        (click)="toggleSearch()"
        [class.active]="isSearchOpen"
        matTooltip="Search snapshots"
      >
        <mat-icon>search</mat-icon>
      </button>

      <button
        mat-raised-button
        color="primary"
        class="add-new-button"
        (click)="onAddNewSnapshot()"
      >
        <mat-icon>add</mat-icon>
        Add New
      </button>
    </div>
  </div>

  <!-- Search Bar (below header, toggleable) -->
  @if (isSearchOpen) {
    <div class="search-section" [@slideDown]>
      <div class="search-input-container">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          #searchInput
          type="text"
          class="search-input"
          placeholder="Search snapshots..."
          [(ngModel)]="searchQuery"
          (input)="onSearch()"
        />
        @if (searchQuery) {
          <button
            mat-icon-button
            class="clear-search-button"
            (click)="clearSearch()"
            matTooltip="Clear search"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>
  }

  <!-- Snapshots List -->
  <div class="snapshots-container">
    @if (!loading() && filteredSnapshots().length > 0) {
      <div class="snapshots-list">
        @for (snapshot of filteredSnapshots(); track snapshot; let i = $index) {
          <div
            class="snapshot-item"
            [class.selected]="isSnapshotSelected(snapshot)"
            [class.current]="isSnapshotCurrent(snapshot)"
            (click)="onSnapshotSelect(snapshot)"
          >
            <!-- Snapshot Info -->
            <div class="snapshot-info">
              <div class="snapshot-header">
                <div class="snapshot-title-section">
                  <span class="snapshot-name">{{ snapshot.name }}</span>
                  <div class="snapshot-date-actions">
                    <span class="snapshot-date">{{
                      snapshot.createdAt | serverDate: "M/d/yy, h:mm a"
                    }}</span>
                    <button
                      mat-icon-button
                      class="action-menu-button"
                      [matMenuTriggerFor]="snapshotMenu"
                      (click)="
                        $event.stopPropagation(); setCurrentSnapshot(snapshot)
                      "
                      matTooltip="More options"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </div>
                </div>
                @if (snapshot.userName) {
                  <div class="snapshot-author-line">
                    <span class="snapshot-author"
                      >by {{ snapshot.userName }}</span
                    >
                  </div>
                }
                <div class="snapshot-description-line">
                  @if (snapshot.content) {
                    <span class="snapshot-description-preview">
                      {{ getDescriptionPreview(snapshot.content) }}
                    </span>
                  } @else {
                    <span class="snapshot-no-description">No description</span>
                  }
                  <button
                    mat-icon-button
                    class="fullscreen-button"
                    (click)="
                      $event.stopPropagation(); openDescriptionModal(snapshot)
                    "
                    matTooltip="View full description"
                  >
                    <mat-icon>open_in_full</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }

    <!-- Menu Template (outside the loop) -->
    <mat-menu #snapshotMenu="matMenu">
      @if (currentMenuSnapshot) {
        <button
          mat-menu-item
          (click)="onEditSnapshot(currentMenuSnapshot, $event)"
        >
          <mat-icon>edit</mat-icon>
          <span>Edit</span>
        </button>
      }
      @if (currentMenuSnapshot) {
        <button
          mat-menu-item
          class="delete-action"
          (click)="onDeleteSnapshotById(currentMenuSnapshot.snapshotId)"
        >
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
      }
    </mat-menu>

    <!-- Loading State -->
    @if (loading()) {
      <div class="loading-container">
        <div class="loading-spinner">
          <mat-icon>refresh</mat-icon>
          <span>Loading snapshots...</span>
        </div>
      </div>
    }

    <!-- Empty State -->
    @if (!loading() && filteredSnapshots().length === 0) {
      <div class="empty-state">
        <div class="empty-icon">
          <mat-icon>photo_camera</mat-icon>
        </div>
        <h3>No snapshots found</h3>
        @if (searchQuery) {
          <p>Try adjusting your search terms</p>
        }
        @if (!searchQuery) {
          <p>Create your first snapshot to get started</p>
        }
      </div>
    }
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <div class="action-buttons-left">
      <button
        mat-stroked-button
        class="apply-default-button"
        (click)="onApplyDefault()"
      >
        Apply Default
      </button>
    </div>

    <div class="action-buttons-right">
      <button mat-button class="cancel-button" (click)="onCancel()">
        Cancel
      </button>

      <button
        mat-raised-button
        color="primary"
        class="apply-button"
        [disabled]="!selectedSnapshot()"
        (click)="onApplySelected()"
      >
        Apply Selected
      </button>
    </div>
  </div>
</div>
